<template>
  <body class="GetInTouch-body">
    <a
      href="mailto:info@wecobi.com?subject=Request to the pitch deck&body=I would like to request access to the pitch deck."
      class="request-access"
    >
      <div class="text-wrapper">
        <div class="title">
          Request access to the <br />
          <span>Pitch Deck</span>
        </div>
        <div class="text">Explore the full opportunity</div>
      </div>
      <div class="arrow-wrapper">
        <img
          class="arrow"
          src="../../../assets/company/arrow.png"
          alt="arrow"
        />
      </div>
    </a>
    <a
      href="mailto:info@wecobi.com?subject=General Inquiry&body=I would like to know more about your company."
      class="contact-us"
    >
      <div class="text-wrapper">
        <div class="title">Contact Us</div>
        <div class="text">Speak to Our Investor Relations Team</div>
      </div>
      <div class="arrow-wrapper">
        <img
          class="arrow"
          src="../../../assets/company/arrow.png"
          alt="arrow"
        />
      </div>
    </a>
  </body>
</template>

<script>
export default {
  name: "GetInTouch",
};
</script>

<style scoped>
.GetInTouch-body {
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}
.request-access,
.contact-us {
  width: 820px;
  height: 251px;
  border-radius: 20px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 40px 50px;
  box-sizing: border-box;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
}

.request-access {
  background-image: url("../../../assets/company/request-pitchdeck.png");
}
.contact-us {
  background-image: url("../../../assets/company/contactus.png");
}
.text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.title {
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
}
.text {
  font-size: 20px;
  font-weight: 400;
  line-height: 1.2;
}
span {
  color: #f98140;
}
.arrow-wrapper {
  width: fit-content;
  align-content: flex-end;
}

.arrow {
  width: 38px;
  height: 81px;
}

@media (max-width: 1024px) {
  .text {
    font-size: 18px;
  }
}
@media (max-width: 744px) {
  .request-access,
  .contact-us {
    padding: 30px;
    height: 200px;
  }
  .title {
    font-size: 22px;
  }
  .text {
    font-size: 14px;
  }
  .arrow {
    width: 19px;
    height: 40px;
  }
}
@media (max-width: 588px) {
  .GetInTouch-body {
    gap: 12px;
  }
  .text-wrapper {
    max-width: 176px;
  }
}
@media (max-width: 460px) {
  .GetInTouch-body {
    flex-direction: column;
  }

  .request-access,
  .contact-us {
    width: 100%;
    height: 160px;
  }
  .text-wrapper {
    max-width: 300px;
  }
}
</style>
